<script setup>

import { radiationTreatmentPlanningOptions, intracavitaryTreatmentPlanning, teleradioOptions, isotopeOptions, masterList } from '@/libraries/RadiationTreatmentObjects'
import { computed, reactive } from 'vue';
import CodesTreatmentCodeDisplay from './CodesTreatmentCodeDisplay.vue';

const props = defineProps(['allCodes'])
const emits = defineEmits(['emitCodes'])

const state = reactive({
  helpOptions: null,
  xCodes: computed(() => {
    const xCodes = [];
    masterList.forEach(radOncCodeList => {
      radOncCodeList.forEach(codeObject => {
        if (codeObject.isSelected) {
          for (let i = 0; i < codeObject.count; i++) {
            xCodes.push({
              code: codeObject.code,
              name: codeObject.name,
              price: codeObject.price
            });
          }
        }
      })
    })
    return xCodes;
  }),
})

function emitCodes() {
  emits('emitCodes', state.xCodes);
}


</script>
<template>
  <CodesTreatmentCodeDisplay :helpArray="radiationTreatmentPlanningOptions" :xCodes="radiationTreatmentPlanningOptions"
    :headerText="'Select treatment level:'" @updateXCodes="emitCodes"/>

  <CodesTreatmentCodeDisplay :helpArray="intracavitaryTreatmentPlanning" :xCodes="intracavitaryTreatmentPlanning"
    :headerText="'Select intracavitary treatment:'" @updateXCodes="emitCodes"/>

  <CodesTreatmentCodeDisplay :helpArray="teleradioOptions" :xCodes="teleradioOptions"
    :headerText="'Select teleradiotherapy:'"  @updateXCodes="emitCodes" />

  <CodesTreatmentCodeDisplay :helpArray="isotopeOptions" :xCodes="isotopeOptions"
    :headerText="'Select radium and radioisotopes:'" @updateXCodes="emitCodes" />
</template>
<style scoped lang="scss"></style>
